export class EventEx {
    listeners: EventListener[];

    constructor() {
        this.listeners = [];
    }

    subscribe(fn: Function) {
        this.listeners.push(new EventListener(fn));
    }

    emit(args = null) {
        for (const listener of this.listeners) {
            if (listener !== null && listener !== undefined) {
                listener.call(args);
            }
        }
    }

    async emitAsync(args: any = null) {
        for (const listener of this.listeners) {
            if (listener !== null && listener !== undefined) {
                await listener.callAsync(args);
            }
        }
    }

    clearListeners() {
        this.listeners = [];
    }
}

export class EventListener {
    fn: Function;

    constructor(fn: Function) {
        this.fn = fn;
    }

    call(args: any) {
        this.fn.call(this, args);
    }

    async callAsync(args: any) {
        await this.fn.call(this, args);
    }
}
